





















import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import DisabledInput from '@/components/shared/DisabledInput.vue';
import Progressbar from '@/components/shared/ProgressBar.vue';
import Connector from '@vue-polkadot/vue-api';
import Collapse from '@/components/shared/Collapse.vue';
import { DeriveStakingOverview } from '@polkadot/api-derive/types';

@Component({
  components: {
    DisabledInput,
    Progressbar,
    Collapse,
  }
})
export default class SummarySession extends Vue {
  private sessionData: any = {};
  private emitedLoaded: boolean = false;
  private sessionResolved: any = {};
  private stakingOverview: any = [];
  private validators: any = [];
  private entries: any = {};
  private subs: any[] = [];
  @Prop({default: 0}) public currentBlock!: number;
  
  @Watch('currentBlock')
  private resolve(): void {
    if (this.sessionData && this.sessionData.info) {
      const arr = Object.entries(this.sessionData.info)
    
      const a: any[] = []
      for (const [key, value] of arr) {
        a.push([key, (value as any).toString()]);
      }

      const m = new Map(a)    
      const obj = Array.from(m)
        .reduce((acc, [ key, val ]) => Object
        .assign(acc, { [key as string]: val }), {});
      
      this.sessionResolved = m
      this.entries = obj
      if (!this.emitedLoaded) {
        this.$emit('loadedSession')
        this.emitedLoaded = true
      }
    }
  }
  
  private async fetchSessionInfo() {
    const { api } = Connector.getInstance();
    this.subs.push(await api.derive.session.progress((value: any) => this.sessionData.info = value))
    this.subs.push(await api.derive.staking.overview(this.updateStakingOverview)); 
  }

  private updateStakingOverview(stakingOverview: DeriveStakingOverview) {
    this.stakingOverview = stakingOverview;
    this.validators = stakingOverview.validators?.map(validator => validator.toString())
  }

  public async mounted() {
    this.fetchSessionInfo();
  }

  // Unsubscribe before destroying component
  public beforeDestroy() {
    this.subs.forEach((sub) => sub());
  }
}
